<template>
  <div class="money-input">
    <div v-if="amountSymbol && amountSymbol === '1'" class="prefix">$</div>
    <div v-else class="prefix">¥</div>
    <div class="input" :class="setUnitClass" @click="clickAmountInput">
      <div v-if="amountUnit" class="unit">{{ amountUnit }}</div>
      <div class="input-text">
        {{ value }}
      </div>
      <div v-if="showCursor" class="cursor"></div>
    </div>
    <div v-if="value" class="clear-amount" @click="clearAmount"><img src="../assets/clear-amount-new.png" alt="" /></div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'AmountInput',
  props: {
    value: {
      default: '',
      type: String,
    },
    showCursor: {
      default: false,
      type: Boolean,
    },
    amountSymbol: {
      default: '',
      type: String,
    },
    amountUnit: {
      default: '',
      type: String,
    },
  },
  data() {
    return {};
  },
  computed: {
    setUnitClass() {
      return this.amountUnit ? 'set-unit' : '';
    },
  },
  methods: {
    clickAmountInput() {
      this.$emit('click-amount-input');
    },
    clearAmount() {
      this.$emit('clear-amount');
    },
  },
});
</script>

<style scoped lang="less">
@keyframes cursor-blinks {
  0% {
    opacity: 1;
    display: block;
  }
  50% {
    opacity: 0;
    display: none;
  }
  100% {
    opacity: 1;
    display: block;
  }
}

.money-input {
  border-bottom: 0.01rem solid rgba(0, 0, 0, 0.06);
  padding-bottom: 0.28rem;
  display: flex;
  align-items: flex-end;
  .prefix {
    font-family: 'MTNewDigitalDisplay-Medium', monospace;
    font-size: 0.38rem;
    line-height: 0.38rem;
    color: #111111;
    text-align: left;
    font-weight: 700;
    margin-right: 0.08rem;
    padding-bottom: 0.02rem;
    padding-left: 0.01rem;
  }
  .input {
    width: 100%;
    height: 0.64rem;
    display: flex;
    letter-spacing: 0.02rem;
    .cursor {
      height: 85%;
      width: 0.04rem;
      animation: cursor-blinks 1.2s infinite steps(1, start);
      border-radius: 0.04rem;
      background: #0a77f5;
      margin-top: 0.04rem;
    }

    .input-text {
      text-align: left;
      font-family: 'MTNewDigitalDisplay-Medium', monospace;
      font-size: 0.68rem;
      color: #111111;
      text-align: left;
      line-height: 0.64rem;
      font-weight: 500;
    }
  }
  .set-unit {
    position: relative;
    .unit {
      position: absolute;
      top: -0.4rem;
      left: -0.02rem;
      font-family: PingFangSC-Regular, sans-serif;
      font-size: 0.24rem;
      color: #666666;
      text-align: left;
      line-height: 0.36rem;
      font-weight: 400;
      padding-left: 0.08rem;
      border-left: 1px solid #d8d8d8;
    }
  }
  .clear-amount {
    display: flex;
    margin-bottom: 0.06rem;
    img {
      width: 0.32rem;
      height: 0.32rem;
    }
  }
}
</style>
